import React, { useState, useEffect, useRef } from "react";

const CustomTimePicker = ({
  selectedTime,
  onTimeSelect,
  isMobile = false,
  driverCountry,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);

  // Generate 48 time slots — 12h for US/CA, 24h for everyone else
  const generateTimeOptions = (countryCode) => {
    const is12Hour = countryCode === "US" || countryCode === "CA";
    const options = [];
    for (let h = 0; h < 24; h++) {
      for (let m of [0, 30]) {
        const hourStr = String(h).padStart(2, "0");
        const minStr = String(m).padStart(2, "0");
        const value = `${hourStr}:${minStr}`;
        let display;
        if (is12Hour) {
          const h12 = h % 12 || 12;
          const ampm = h >= 12 ? "PM" : "AM";
          if (h === 0 && m === 0) display = "Midnight";
          else if (h === 12 && m === 0) display = "Noon";
          else display = `${h12}:${minStr} ${ampm}`;
        } else {
          display = value;
        }
        options.push({ display, value });
      }
    }
    return options;
  };

  const timeOptions = generateTimeOptions(driverCountry);

  const getDisplayLabel = () => {
    const match = timeOptions.find((o) => o.value === selectedTime);
    if (match) return match.display;
    return driverCountry === "US" || driverCountry === "CA" ? "10:00 AM" : "10:00";
  };

  // Close on outside click
  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setIsOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div ref={ref} className="relative flex items-center w-full">
      {/* Trigger */}
      <button
        type="button"
        onClick={(e) => { e.stopPropagation(); setIsOpen((p) => !p); }}
        className="flex items-center gap-2 w-full focus:outline-none"
      >
        <span className="text-md font-semibold font-body text-dark">
          {getDisplayLabel()}
        </span>
      </button>

      {/* Dropdown */}
      {isOpen && (
        <div className="absolute top-full left-0 mt-2 z-[9999] min-w-[150px]">
          <div className="max-h-52 overflow-y-auto bg-surface border border-surface-border rounded-xl shadow-card">
            {timeOptions.map((opt) => (
              <div
                key={opt.value}
                onClick={(e) => {
                  e.stopPropagation();
                  onTimeSelect(opt.value);
                  setIsOpen(false);
                }}
                className={`px-4 py-2.5 cursor-pointer text-sm font-body font-medium transition-colors border-b border-surface-border last:border-b-0 ${
                  opt.value === selectedTime
                    ? "bg-primary-soft text-primary font-semibold"
                    : "text-dark hover:bg-surface-raised"
                }`}
              >
                {opt.display}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomTimePicker;
